import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../Pages/Layout";
import PageNotFound from "../Pages/NotFound/404";
import { Login } from "../Pages/Login/Login";
import { Users } from "../Pages/UserManagement/Users/Users";
import { AddUser } from "../Pages/UserManagement/Users/AddUser";
import CustomServiceRequest from "../Pages/Dashboard/custom service request/CustomServiceRequest";
import { CustomRequestDetails } from "../Pages/Dashboard/custom service request/CustomRequestDetails";
import { Role } from "../Pages/UserManagement/Role/Role";
import { AddRole } from "../Pages/UserManagement/Role/AddRole";
import { EditRole } from "../Pages/UserManagement/Role/EditRole";
import Dashboard from "../Pages/Dashboard/Dashboard";
import { Bookings } from "../Pages/Booking Management/Bookings/Bookings";
import { AddBooking } from "../Pages/Booking Management/Bookings/AddBooking";
import { UpdateBooking } from "../Pages/Booking Management/Bookings/UpdateBooking";
import { BookingStatus } from "../Pages/Booking Management/BookingStatus/BookingStatus";
import { Vendors } from "../Pages/Other Master/Vendor/Vendors";
import { Drivers } from "../Pages/Other Master/Driver/Drivers";
import { TermsAndConditions } from "../Pages/Policy/TermsAndConditions";
import { PrivacyPolicy } from "../Pages/Policy/PrivacyPolicy";
import { AddTermsCondition } from "../Pages/Policy/AddTermsAndCondition";
import { AddPrivacyPolicy } from "../Pages/Policy/AddPrivacyPolicy";
import { UpdateTermsCondition } from "../Pages/Policy/UpdateTermsAndCondition";
import { UpdatePrivacyPolicy } from "../Pages/Policy/UpdatePrivacyPolicy";
import { Cars } from "../Pages/Other Master/Car/Cars";
import { PanaltyStructure } from "../Pages/Policy/PanaltyStructure";
import { AddPanaltyStructure } from "../Pages/Policy/AddPanaltyStructure";
import { UpdatePanaltyStructure } from "../Pages/Policy/UpdatePanaltyStructure";
import { UpdateBookingStatus } from "../Pages/Booking Management/BookingStatus/UpdateBookingStatus";
import { UpdateUser } from "../Pages/UserManagement/Users/UpdateUsers";
const PageRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/dashboard/custom-service-request"
            element={<CustomServiceRequest />}
          />
          {/* <Route path="/dashboard/custom-service-requet/add" element={<AddCustomRequest/>} /> */}
          <Route
            path="/dashboard/custom-service-requet/view/:salonId"
            element={<CustomRequestDetails />}
          />

          <Route path="/user-management/users" element={<Users />} />
          <Route path="/user-management/user/add" element={<AddUser />} />
          <Route
            path="/user-management/users/update/:id"
            element={<UpdateUser />}
          />
          {/* <Route path="/user-management/permission" element={<Permission/>} /> */}
          <Route path="/user-management/role" element={<Role />} />
          <Route path="/user-management/role/add" element={<AddRole />} />
          <Route path="/user-management/role/edit/:id" element={<EditRole />} />

          <Route
            path="/booking-management/booking/add"
            element={<AddBooking />}
          />
          <Route
            path="/booking-management/booking/update/:id"
            element={<UpdateBooking />}
          />
          <Route path="/booking-management/bookings" element={<Bookings />} />

          <Route
            path="/booking-management/bookingStatus"
            element={<BookingStatus />}
          />
          <Route
            path="/booking-management/bookingStatus/update/:id"
            element={<UpdateBookingStatus />}
          />

          <Route path="/other-master/vendors" element={<Vendors />} />
          <Route path="/other-master/drivers" element={<Drivers />} />
          <Route path="/other-master/cars" element={<Cars />} />

          <Route path="/termsConditions" element={<TermsAndConditions />} />
          <Route path="/termsConditions/add" element={<AddTermsCondition />} />
          <Route
            path="/termsConditions/update/:id"
            element={<UpdateTermsCondition />}
          />

          <Route path="/policies" element={<PrivacyPolicy />} />
          <Route path="/policies/add" element={<AddPrivacyPolicy />} />
          <Route
            path="/policies/update/:id"
            element={<UpdatePrivacyPolicy />}
          />

          <Route path="/panaltyStructures" element={<PanaltyStructure />} />
          <Route
            path="/panaltyStructures/add"
            element={<AddPanaltyStructure />}
          />
          <Route
            path="/panaltyStructures/update/:id"
            element={<UpdatePanaltyStructure />}
          />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
export default PageRoutes;
